import ModalBtn from '../../molecules/modalButton/view';
import { BiEdit } from 'react-icons/bi';
import { updateTax, deleteTax } from '../../../usecases/taxes-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import ButtonConfirm from '../../atoms/ButtonConfirm/view';
import TaxForm from '../TaxForm/view';

function EditTax({ data }) {
    const modalId = 'edit-tax-' + data.id;

    function handleSubmit(dataToSend) {
        updateTax(data.id, dataToSend)
            .then(() => {
                dispatchCustomEvent('popup', { message: 'Impuesto Actualizado' });
                dispatchCustomEvent('close-' + modalId + '-modal', {});
                dispatchCustomEvent('update-taxes', {});
            })
            .catch(err => {
                if (err.status === 429) {
                    dispatchCustomEvent('popup', { message: 'Alcanzaste el limite' });
                } else {
                    dispatchCustomEvent('popup', {
                        message: err.response?.data?.message || 'Error al actualizar impuesto',
                        type: 'error',
                    });
                }
                dispatchCustomEvent('loading-btn', {});
            });
    }

    function handleDelete() {
        deleteTax(data.id)
            .then(() => {
                dispatchCustomEvent('popup', { message: 'Impuesto Eliminado' });
                dispatchCustomEvent('close-' + modalId + '-modal', {});
                dispatchCustomEvent('update-taxes', {});
            })
            .catch(err => {
                if (err.status === 429) {
                    dispatchCustomEvent('popup', { message: 'Alcanzaste el limite' });
                } else {
                    dispatchCustomEvent('popup', {
                        message: err.response?.data?.message || 'Error al eliminar impuesto',
                        type: 'error',
                    });
                }
                dispatchCustomEvent('loading-btn', {});
            });
    }

    return (
        <ModalBtn
            id={modalId}
            title={<BiEdit />}
            type="action"
            style={{ border: 'none' }}
        >
            <TaxForm
                initialData={data}
                onSubmit={handleSubmit}
                loadingId={'edit-tax-btn-' + data.id}
                title={'Editar Impuesto: ' + data.name}
                submitLabel="Guardar Cambios"
                modalId={modalId}
                showDelete={true}
                onDelete={handleDelete}
            />
        </ModalBtn>
    );
}

export default EditTax;
